module.exports = __webpack_public_path__ + "img/employment.ff585b11.png";